import { Box, Text } from '@chakra-ui/layout'
import { Icon } from 'components/atoms/Icon'
import FileAltWhite from '../../../../../components/atoms/Icon/svg/file-alt-white.svg'

import { useToast } from '@chakra-ui/react'
import { useContractContext } from 'contexts/contract'
import React from 'react'
import { useParams } from 'react-router-dom'
import formatter from 'utils/formatter'
import { AttachmentProps } from '../../ContractDetail/interfaces'

export interface FormFileDataRootProps {
    attachments?: AttachmentProps[]
    openModal?: () => void
}

const FormFileData: React.FC<FormFileDataRootProps> = ({
    attachments,
    openModal
}) => {
    const { downloadAnnex } = useContractContext()

    const toast = useToast()

    const { id = '' } = useParams()

    const download = async (idAnnex: string, name: string) => {
        await downloadAnnex(id, idAnnex)
            .then(res => {
                const data =
                    'data:' +
                    res.headers['content-type'] +
                    ';base64,' +
                    res.data

                const link = document.createElement('a')
                link.href = data as string
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
                link.parentNode?.removeChild(link)
            })
            .catch(() => {
                toast({
                    title: 'Sentimos muito!',
                    description: 'Ocorreu um erro, tente novamente mais tarde.',
                    position: 'bottom-left',
                    status: 'error',
                    isClosable: true
                })
            })
    }

    return (
        <Box
            display="flex"
            overflowY="auto"
            w="100%"
            justifyContent="center"
            flexDirection="column"
        >
            {attachments ? (
                attachments.map(({ id: idAnnex, nome, tipo, data }, key) => {
                    return (
                        <Box
                            key={key}
                            bg={key % 2 === 0 ? 'grayscale.50' : 'white'}
                            alignItems="center"
                            flexDirection="row"
                            padding="0px 24px"
                            w="100%"
                        >
                            <Box
                                display="flex"
                                height="52px"
                                flexDir="row"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Text
                                    whiteSpace="pre"
                                    color="grayscale.800"
                                    fontSize={14}
                                >
                                    {formatter.dataWithHour(data)} -{' '}
                                    <strong>{nome}</strong>
                                </Text>
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Box
                                        bg="#18315A"
                                        padding="1px 4px"
                                        mr="18px"
                                        rounded={2}
                                    >
                                        <Text
                                            whiteSpace="pre"
                                            color="#F4F5FB"
                                            fontWeight={700}
                                            maxWidth="292px"
                                            fontSize={12}
                                        >
                                            {formatter.operationName(tipo)}
                                        </Text>
                                    </Box>
                                    <Icon
                                        data-testid="button-download"
                                        name="download"
                                        cursor="pointer"
                                        onClick={() => download(idAnnex, nome)}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    )
                })
            ) : (
                <Box
                    display="flex"
                    py="32px"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    textAlign="center"
                    zIndex={12}
                    gap={2}
                    cursor="pointer"
                    onClick={openModal}
                >
                    <Box
                        h="129px"
                        backgroundImage={FileAltWhite}
                        display="flex"
                        flexDirection="column"
                        backgroundRepeat="no-repeat"
                        backgroundPosition="center"
                        justifyContent="center"
                    >
                        <Text whiteSpace="pre" color="black" fontWeight="700">
                            Nenhum anexo selecionado.
                        </Text>
                        <Text
                            whiteSpace="pre"
                            color="black"
                            fontWeight="700"
                            textDecoration="underline"
                        >
                            Faça upload agora mesmo.
                        </Text>
                        <Text
                            whiteSpace="pre"
                            color="black"
                            maxWidth="292px"
                            fontSize={12}
                        >
                            O arquivo deve possuir tamanho máximo de 5 Mb <br />{' '}
                            (cinco megabytes), nos formatos JPG ou PDF.
                        </Text>
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default FormFileData
